module.exports = __webpack_public_path__ + "img/theme5.eed30166.png";